import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import type { AuthRole } from '..';
import IdentityContext from '../../../contexts/IdentityContext';
import useStudioGroup from '../../../hooks/useStudioGroup';

const faqLinks: Record<string, Record<string, string>> = {
  SO: {
    ANONYMOUS: 'link-to-manual-anonymous-SO',
    TEACHER: 'link-to-manual-teachers-SO',
    STUDENT: 'link-to-manual-student-SO',
  },
  ES: {
    ANONYMOUS: 'link-to-manual-anonymous-ES',
    TEACHER: 'link-to-manual-teachers-ES',
    STUDENT: 'link-to-manual-student-ES',
  },
  BAO: {
    ANONYMOUS: 'link-to-manual-teachers-BAO',
    TEACHER: 'link-to-manual-teachers-BAO',
  },
  VO: {
    STUDENT: 'link-to-manual-students-VO',
    TEACHER: 'link-to-manual-teachers-VO',
  },
};

const Link = ({ url, translationKey }: { url: string; translationKey: string }) => {
  const { t } = useTranslation();
  return (
    <p
      className="list-sections__paragraph list-sections__paragraph__link"
      dangerouslySetInnerHTML={{
        __html: t(translationKey, {
          url,
        }),
      }}
    />
  );
};

interface FaqProps {
  authRole: AuthRole;
}

export default function Faq({ authRole }: FaqProps) {
  const {
    identity: { isAuthenticated },
  } = useContext(IdentityContext);

  const studioGroup = useStudioGroup();

  return (
    <>
      <Link url={faqLinks[studioGroup][authRole]} translationKey={`PAGES.HELP.SECTIONS.FAQ.${authRole}`} />
      {studioGroup === 'VO' && !isAuthenticated && (
        <>
          <Link url={faqLinks.VO.TEACHER} translationKey="PAGES.HELP.SECTIONS.FAQ.LINKS.TEACHER" />
          <Link url={faqLinks.VO.STUDENT} translationKey="PAGES.HELP.SECTIONS.FAQ.LINKS.STUDENT" />
        </>
      )}
    </>
  );
}
